import { ChartCard } from "@/components/ChartCard";
import { PageHeader } from "@/components/Widgets";
import { CHARTS } from "@/lib/chartDefs";
import { useData } from "@/context/DataContext";

export const Chart = ({ k, className }) => <ChartCard id={k} {...CHARTS[k]} className={className} />;

export const ChartGrid = ({ keys }) => (
  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
    {keys.map((k) => <Chart key={k} k={k} />)}
  </div>
);

const make = (kicker, title, keys) => function ChartPage() {
  const { data, filters } = useData();
  const e = data.model.entities.find((x) => x.code === filters.entity);
  return (
    <div data-testid={`page-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <PageHeader kicker={kicker} title={e ? `${title} - ${e.short}` : title} />
      <ChartGrid keys={keys} />
    </div>
  );
};

export const RevenuePage = make("Income analysis", "Revenue", ["revenueTrend", "revenueByEntity", "revenueMix", "ghInorx", "actualVsProjected"]);
export const ExpensesPage = make("Cost and profitability", "Expenses and EBITDA", ["ebitdaMargin", "opexTrend", "ebitdaMix"]);
export const CapexPage = make("Investment programme", "Capex and Projects", ["capexByEntity", "capexByProject"]);
export const DebtCharts = () => <ChartGrid keys={["debtFlows", "interest"]} />;
export const CashCharts = () => <ChartGrid keys={["ncfTrend", "cashBalances"]} />;
